// extracted by mini-css-extract-plugin
export var borderRadius = "_dl-4";
export var large = "_dl-3";
export var logoContainer = "_dl-0";
export var nameLogo = "_dl-2";
export var small = "_dl-1";